import React from 'react'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles'
import SubmitButtonSection from 'pages/documentscontent/precedentsadmin/SubmitButtonSection'
import SubscriptionTierSectionContainer from 'redux/containers/pages/precedentscontent/precedentsadmin/SubscriptionTierSectionContainer'

const SubscriptionSection = () => {
  const theme = createMuiTheme({ palette: { primary: { main: '#004b7a' } } })

  return (
    <MuiThemeProvider {...{ theme }}>
      <SubscriptionTierSectionContainer />
      <SubmitButtonSection />
    </MuiThemeProvider>
  )
}

export default SubscriptionSection
